module.exports = __webpack_public_path__ + "img/us_1.85f2819e.jpg";